import {motion} from 'framer-motion';
import {Portal, useLocalStorage} from 'platform/components';
import {getSize, HStack, Show, Text} from 'platform/foundation';
import {useTheme} from 'styled-components';

import {useState} from 'react';

import {browserStorageKey} from '@dms/config';

import {BundleSize} from './components/BundleSize';
import {MemoryUsage} from './components/MemoryUsage';
import {PendingRequests} from './components/PendingRequests';

interface PanelPosition {
  x: number;
  y: number;
}

const DEFAULT_POSITION: PanelPosition = {
  x: 50,
  y: 12,
};

export function PerformancePanel() {
  const theme = useTheme();

  const [isPerformanceTrackingEnabled] = useLocalStorage<boolean>(
    browserStorageKey.PERFORMANCE_TRACKING_ENABLED,
    false
  );

  const [panelPosition, setPanelPosition] = useState<PanelPosition>(DEFAULT_POSITION);

  const handleDragEnd = (_event: any, info: any) => {
    setPanelPosition({
      x: info.point.x,
      y: info.point.y,
    });
  };

  return (
    <Show when={isPerformanceTrackingEnabled}>
      <Portal>
        <motion.div
          drag
          dragMomentum={false}
          dragElastic={0}
          onDragEnd={handleDragEnd}
          initial={{x: panelPosition.x, y: panelPosition.y}}
          style={{
            position: 'fixed',
            left: 0,
            top: 0,
            x: panelPosition.x,
            y: panelPosition.y,
            zIndex: theme.zIndices.LIGHTBOX_OVERLAY,
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            cursor: 'grab',
            userSelect: 'none',
            touchAction: 'none',
            paddingLeft: getSize(1),
            paddingRight: getSize(1),
          }}
        >
          <HStack spacing={2}>
            <PendingRequests />
            <Text color="tertiary">|</Text>
            <MemoryUsage />
            <Text color="tertiary">|</Text>
            <BundleSize />
          </HStack>
        </motion.div>
      </Portal>
    </Show>
  );
}
